export default {
  exploreApps: "Explore Apps",
};
